export const TitleStyle = {
  background:
    'linear-gradient(180deg, #FFFFFF 0%, rgba(254, 254, 254, 0.99) 33%, rgba(251, 251, 251, 0.97) 51%, rgba(246, 246, 246, 0.93) 65%, rgba(239, 239, 239, 0.87) 78%, rgba(230, 230, 230, 0.8) 89%, rgba(220, 220, 220, 0.71) 99%, rgba(219, 219, 219, 0.7) 100%)',
  textAlign: 'center',
  zIndex: 2,
};
